export default {
  maintenance: 'Maintenance',
  distance: 'Distance',
  asset: 'Asset',
  notFound: 'Asset not found.',
  registration: 'Registration',
  registrationWith: 'Registration ({number})',
  insurance: 'Insurance',
  insuranceWith: 'Insurance ({details})',
  warranty: 'Warranty',
  odometer: 'Odometer',
  noTrackingHint: 'Turn on maintenance tracking or distance logging when editing this asset to record service history and odometer readings.',
  maintenanceRecorded: 'Maintenance recorded.',
  whatWasDone: 'What was done',
  whatWasDonePlaceholder: 'e.g. 40,000 km service',
  provider: 'Provider',
  cost: 'Cost ($)',
  odometerKm: 'Odometer (km)',
  nextDueDate: 'Next due date',
  nextDueKm: 'Next due at (km)',
  recordService: 'Record service',
  serviceEmptyTitle: 'No service history',
  serviceEmptyMessage: 'Record each service or repair so the next one is never missed.',
  nextDue: 'Next due {when}',
  or: ' or ',
  readingLogged: 'Reading logged.',
  driver: 'Driver',
  notRecorded: 'Not recorded',
  logReading: 'Log reading',
  readingsEmptyTitle: 'No readings',
  readingsEmptyMessage: 'Log the odometer regularly; distance travelled is worked out between readings.',
  travelledAcross: '{km} travelled across {count} readings.',
  updated: 'Asset updated.',
  added: 'Asset added.',
  editTitle: 'Edit asset',
  addTitle: 'Add asset',
  serialNumber: 'Serial number',
  category: 'Category',
  purchaseDate: 'Purchase date',
  warrantyExpires: 'Warranty expires',
  warrantyHint: 'Admins are emailed 15 days before',
  regoAndInsurance: 'Registration and insurance',
  registrationNumber: 'Registration number',
  registrationExpires: 'Registration expires',
  insurer: 'Insurer',
  policyNumber: 'Policy number',
  insuranceExpires: 'Insurance expires',
  trackMaintenance: 'Track maintenance',
  logDistance: 'Log distance travelled',
  retired: 'Retired (broken, sold or written off)',
  assigned: 'Asset assigned.',
  assignTitle: 'Assign asset',
  employee: 'Employee',
  selectEmployee: 'Select an employee',
  assignedOn: 'Assigned on',
  notesOptional: 'Notes (optional)',
  assigning: 'Assigning…',
  assign: 'Assign',
  returned: 'Asset returned.',
  markReturnedTitle: 'Mark as returned',
  returnedOn: 'Returned on',
  conditionNotes: 'Condition / notes (optional)',
  markReturned: 'Mark returned',
  assets: 'Assets',
  showReturned: 'Show returned',
  employeeEmptyTitle: 'No assets',
  employeeEmptyAll: 'Nothing has been assigned to this employee.',
  employeeEmptyCurrent: 'Nothing is currently assigned. Assign equipment from the Assets page.',
  loanFrom: '{category} · from {date}',
  loanReturned: ' · returned {date}',
  returnedBadge: 'Returned',
}
